export function getServer() {
  var currentURL = window.location.href;
  var urlObject = new URL(currentURL);
  var baseURL = urlObject.protocol + '//' + urlObject.host;
  return baseURL;
}

//接口请求地址
export function getAPI() {
  let ApiHost = "";

  if (process.env.NODE_ENV == "development") {
    ApiHost = "/wwwApi";
  } else {
    ApiHost = getServer();
  }
  return ApiHost;
}

// 是否在PC中
function checkPcClient() {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    return false;
  }
  return true;
};

// 判断是否为 IE 浏览器
export function isIEClient() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE '); // IE 10 及更早版本
  const trident = ua.indexOf('Trident/'); // IE 11
  return msie > -1 || trident > -1;
}

export function replaceUrlParam(url, arg, argVal) {
  var pattern = new RegExp('([\?|\&])(' + arg + '=)([^&]+)', 'ig');
  var replaceText = arg + '=' + argVal;
  return url.match(pattern) ? url.replace(pattern, '$1' + replaceText) : (url.match('[?]') ? url + '&' + replaceText : url + '?' + replaceText);
}

//是否在微信环境下
export function isWeixinClient() {
  if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > 0) {
    return true;
  }
  return false;
}

//是否在安卓环境下
export  function isAndroidClient() {
  let u = navigator.userAgent;
  if (u.indexOf("Android") != -1 || u.indexOf('Adr') != -1) {
    return true;
  }
  return false;
};

export function isIOSEnvironment() {
  // const platform = window.navigator.platform;
  // const iOSPlatforms = ['iPhone', 'iPad', 'iPod'];

  // if (iOSPlatforms.includes(platform)) {
  //   console.log(123);
  //   return true;
  // }
  
  // if (/MacIntel/.test(platform) && navigator.maxTouchPoints > 1) {
  //   console.log(456);
  //   return true;
  // }
  
  // console.log(789);
  // return false;
  const userAgent = window.navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export function getCookie(name,escapeFlag) {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)){
    return (escapeFlag?arr[2]:unescape(arr[2]));
  }
  return null;
}

//设置cookie
export function setCookie (c_name, value, expiredays, domain) {
  let exdate = new Date();
  //exdate.setDate(exdate.getDate()+expiredays);
  exdate.setTime(exdate.getTime()+60*1000*expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + (domain?';domain='+domain:'')+';path=/';
};

//删除cookie
export function delCookie (name,domain) {
  setCookie(name, "", -1,domain);
};

/**
 * format  格式
 * timestamp  时间戳，默认取当前时间
 * wfDate('Y-m-d','1350052653');//将时间戳转换成了2012-10-12
 * wfDate('Y-m-d H:i:s','1350052653');//得到的结果是2012-10-12 22:37:33
 * wfDate('Y/m/d H:i:s',1350052653);
 * wfDate('Y年m月d日 H:i:s','1350052653');
 */
function formatDate(format, timestamp) {
  let a, jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date());
  let pad = function (n, c) {
    if ((n = n + "").length < c) {
      return new Array(++c - n.length).join("0") + n;
    } else {
      return n;
    }
  };
  let txt_weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  let txt_ordin = { 1: "st", 2: "nd", 3: "rd", 21: "st", 22: "nd", 23: "rd", 31: "st" };
  let txt_months = [" ", "一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
  let f = {
    // Day
    d: function () {
      return pad(f.j(), 2)
    },
    D: function () {
      return f.l().substr(0, 3)
    },
    j: function () {
      return jsdate.getDate()
    },
    l: function () {
      return txt_weekdays[f.w()]
    },
    N: function () {
      return f.w() + 1
    },
    S: function () {
      return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
    },
    w: function () {
      return jsdate.getDay()
    },
    z: function () {
      return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0
    },

    // Week
    W: function () {
      let a = f.z(), b = 364 + f.L() - a;
      let nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
      if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
        return 1;
      } else {
        if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
          nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
          return date("W", Math.round(nd2.getTime() / 1000));
        } else {
          return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
        }
      }
    },

    // Month
    F: function () {
      return txt_months[f.n()]
    },
    m: function () {
      return pad(f.n(), 2)
    },
    M: function () {
      return f.F().substr(0, 3)
    },
    n: function () {
      return jsdate.getMonth() + 1
    },
    t: function () {
      let n;
      if ((n = jsdate.getMonth() + 1) == 2) {
        return 28 + f.L();
      } else {
        if (n & 1 && n < 8 || !(n & 1) && n > 7) {
          return 31;
        } else {
          return 30;
        }
      }
    },

    // Year
    L: function () {
      let y = f.Y();
      return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
    },
    //o not supported yet
    Y: function () {
      return jsdate.getFullYear()
    },
    y: function () {
      return (jsdate.getFullYear() + "").slice(2)
    },

    // Time
    a: function () {
      return jsdate.getHours() > 11 ? "pm" : "am"
    },
    A: function () {
      return f.a().toUpperCase()
    },
    B: function () {
      // peter paul koch:
      let off = (jsdate.getTimezoneOffset() + 60) * 60;
      let theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
      let beat = Math.floor(theSeconds / 86.4);
      if (beat > 1000) beat -= 1000;
      if (beat < 0) beat += 1000;
      if ((String(beat)).length == 1) beat = "00" + beat;
      if ((String(beat)).length == 2) beat = "0" + beat;
      return beat;
    },
    g: function () {
      return jsdate.getHours() % 12 || 12
    },
    G: function () {
      return jsdate.getHours()
    },
    h: function () {
      return pad(f.g(), 2)
    },
    H: function () {
      return pad(jsdate.getHours(), 2)
    },
    i: function () {
      return pad(jsdate.getMinutes(), 2)
    },
    s: function () {
      return pad(jsdate.getSeconds(), 2)
    },
    //u not supported yet

    // Timezone
    //e not supported yet
    //I not supported yet
    O: function () {
      let t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
      if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
      return t;
    },
    P: function () {
      let O = f.O();
      return (O.substr(0, 3) + ":" + O.substr(3, 2))
    },
    //T not supported yet
    //Z not supported yet

    // Full Date/Time
    c: function () {
      return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()
    },
    //r not supported yet
    U: function () {
      return Math.round(jsdate.getTime() / 1000)
    }
  };

  return format.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
    let ret;
    if (t != s) {
      // escaped
      ret = s;
    } else if (f[s]) {
      // a date function exists
      ret = f[s]();
    } else {
      // nothing special
      ret = s;
    }
    return ret;
  });
}

/**
 * 获取今天以前/之后的几天
 * @param day
 * @returns {Date} 时间戳
 */
export function getDay(dayNumber = 0, formate = 'Y-m-d') {
  let today = new Date();
  let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * dayNumber;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  // return today.getTime()/1000;
  return formatDate(formate, today.getTime() / 1000);
}

export function getLastMonth(dayNumber = 0, formate = 'Y-m-d') {
  let today = new Date();
  let lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
  return formatDate(formate, lastMonth / 1000);
}

export function strDate(val, formate = 'Y-m-d') {
  if (!val) {
    return '';
  }
  if (val.length == 14) {
    return val.substr(0, 4) + '-' + val.substr(4, 2) + '-' + val.substr(6, 2) + ' ' + val.substr(8, 2) + ':' + val.substr(10, 2) + ':' + val.substr(12, 2);
  } else if (val.length == 12) {
    return val.substr(0, 4) + '-' + val.substr(4, 2) + '-' + val.substr(6, 2) + ' ' + val.substr(8, 2) + ':' + val.substr(10, 2);
  } else if (val.length == 8) {
    return val.substr(0, 4) + '-' + val.substr(4, 2) + '-' + val.substr(6, 2);
  }
  return val;
}

export function secTotime(s) {
  var t
  if (s > -1) {
    var hour = Math.floor(s / 3600)
    var min = Math.floor(s / 60) % 60
    var sec = s % 60
    if (hour < 10) {
      t = '0' + hour + ":"
    } else {
      t = hour + ":"
    }
    if (min < 10) {
      t += "0"
    }
    t += min + ":"
    if (sec < 10) {
      t += "0"

    }
    t += sec;//t += sec.toFixed(2)
  }
  return t
}

export function secToMinutes(s){
  var t = '';
  if (s > -1) {
    var min = Math.floor(s / 60) % 60
    var sec = s % 60
    if (min < 10) {
      t += "0"
    }
    t += min + ":"
    if (sec < 10) {
      t += "0"

    }
    t += sec;
  }
  return t
}

//每超过3位数，添加逗号 保留两位小数
export function formatNumber(nStr, decimalNum = 2) {
  if (nStr == null) {
    return "-";
  }
  if (nStr == '') {
    nStr = 0;
  }
  nStr = parseFloat(nStr).toFixed(decimalNum);
  nStr += '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? '.' + x[1] : '';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

/**
 * 数组去重
 * @param grade 
 * @returns {Array} 合并后的数组
 */
export function mergeGrade(arr1, arr2, key) {
  if (!Array.isArray(arr1) && !Array.isArray(arr2)) return []
  
  // 将 arr1 转换为对象形式，以 key 值作为索引
  const arr1Map = arr1.reduce((map, obj) => {
    map[obj[key]] = obj;
    return map;
  }, {});

  // 遍历 arr2 中的对象，将其合并到 arr1Map 中
  arr2.forEach(obj2 => {
    const existingObj = arr1Map[obj2[key]];

    if (existingObj) {
      // 如果 arr1Map 中已存在相同 key 值的对象，则执行属性合并操作
      arr1Map[obj2[key]] = {...existingObj, ...obj2};
    } else {
      // 如果 arr1Map 中不存在相同 key 值的对象，则直接添加到 arr1Map 中
      arr1Map[obj2[key]] = obj2;
    }
  });

  // 返回合并后的对象数组
  return Object.values(arr1Map);
}

export function timeShow(val) {
  return (val == '0000-00-00 00:00:00' ? '' : val);
}

export function htmlSpecialCharsDecode(str) {
  if(!str) return '';
  str = str.replace(/&amp;/g, '&');
  str = str.replace(/&lt;/g, '<');
  str = str.replace(/&gt;/g, '>');
  str = str.replace(/&quot;/g, '\"');
  str = str.replace(/&#039;/g, '\'');
  return str;
}

export function strtoArray(str){
  let arr = [];
  if(str){
      str = this.$tools.htmlSpecialCharsDecode(str).replaceAll('"','');
  }
  if(str){
      arr = str.split(',');
  }
  return arr;
}

//防抖   当一个动作连续触发，只执行最后一次
export function debounce(fn, delay = 500) {
  let timer;
  return function () {
      if (timer) {
          clearTimeout(timer)
      }
      timer = setTimeout(() => {
          fn.apply(this, arguments);
          timer = null;
      }, delay)
  }
};

export function wfGetUrlParam(url, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象

  if(url && url.indexOf("?")!=-1){
    var r = url.split('?')[1].match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
  }

  return ''; //返回参数值
}

//通过句柄获取函数名称
export function getFName(fn) {
  return (/^[\s\(]*function(?:\s+([\w$_][\w\d$_]*))?\(/).exec(fn.toString())[1] || "";
}

export function addEvent(obj, type, fn, opts) {
  let fn_name = getFName(fn);
  obj["evt" + type + fn_name] = obj["evt" + type + fn_name] || null;
  if (!obj["evt" + type + fn_name]) {
    obj["evt" + type + fn_name] = function (event) {
      event = event || window.event;

      //防止窗体改变时，执行两次
      if (window.resizeTimer) {
        clearTimeout(window.resizeTimer);
        window.resizeTimer = null;
      }
      window.resizeTimer = setTimeout(function () {
        fn.call(obj, opts || {}, event);
      }, 100);
    };
  }

  if (obj.addEventListener) {
    obj.addEventListener(type, obj["evt" + type + fn_name], false);
  } else if (obj.attachEvent) {
    obj.attachEvent("on" + type, obj["evt" + type + fn_name]);
  }
}

export function removeEvent(obj, type, fn) {
  let fn_name = getFName(fn);
  if (typeof obj.removeEventListener != "undefined") {
    obj.removeEventListener(type, obj["evt" + type + fn_name], false);
  } else if (typeof obj.detachEvent != "undefined") {
    if (fn && obj["evt" + type + fn_name]) {
      obj.detachEvent("on" + type, obj["evt" + type + fn_name]);
    } else {
      obj["on" + type] = null;
    }
  }
}

/**
 * 判断给定值是否为空
 * @param {*} value - 要判断的值
 * @returns {boolean} - 如果值为空，则返回 true；否则返回 false
 */
export function isEmpty(value) {
  // 检查 null 或 undefined
  if (value === null || value === undefined) {
    return true; // null 或 undefined 视为空
  }

  // 检查字符串或数组
  if (typeof value === "string" || Array.isArray(value)) {
    return value.length === 0; // 字符串或数组为空当长度为0
  }

  // 检查对象
  if (typeof value === "object") {
    return Object.keys(value).length === 0; // 对象为空当属性个数为0
  }

  return false; // 其他类型默认不为空
}

export let access_token = 'aiAccessToken';
export let login_token = 'aiLoginToken';
export let isPcClient = checkPcClient();
export let wfDate = formatDate;


// WEBPACK FOOTER //
// ./src/assets/js/tools.js